// Lightweight in-memory cache used to make admin page navigations feel instant.
// Pages read the last known state synchronously on mount, then refetch in the
// background and update state — no full-page "Loading…" blocker on repeat visits.

const cache = new Map();

export function getCached(key) {
  return cache.get(key);
}

export function setCached(key, value) {
  cache.set(key, value);
}

export function invalidateCache(prefix) {
  if (!prefix) { cache.clear(); return; }
  for (const k of Array.from(cache.keys())) {
    if (k === prefix || k.startsWith(prefix)) cache.delete(k);
  }
}
